import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export function IconCoins({
    className = '',
    width = 14,
    height = 14,
    ...rest
}) {
    return (
        <svg
            height={width}
            width={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                d="M.647 9.74c1.34.896 3.686 1.49 6.353 1.49s5.013-.594 6.353-1.49c.415.383.647.81.647 1.26 0 1.656-3.137 3-7 3s-7-1.344-7-3c0-.45.232-.877.647-1.26zm12.706-4c.415.383.647.81.647 1.26 0 1.656-3.137 3-7 3S0 8.656 0 7c0-.45.232-.877.647-1.26C1.987 6.635 4.333 7.23 7 7.23s5.013-.594 6.353-1.49zM7 0c3.863 0 7 1.344 7 3s-3.137 3-7 3-7-1.344-7-3 3.137-3 7-3z"
                className={css.colored}
            />
        </svg>
    );
}

export default IconCoins;
